import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {
  msalInstance,
  msalReady,
  isMsalConfigured,
  isInsideIframe,
} from "./msalInstance";
import { apiTokenRequest } from "./msalConfig";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

/**
 * Request interceptor:
 *  1. If MSAL is configured and a user is signed in, attach a Bearer access
 *     token acquired silently.
 *  2. Otherwise, leave the dev-mode `X-User-Email` header (set by lib/auth.jsx)
 *     untouched so the preview keeps working.
 */
async function attachAuth(config) {
  if (!isMsalConfigured() || isInsideIframe()) return config;
  try {
    await msalReady;
    const account = msalInstance.getActiveAccount();
    if (!account) return config;
    let resp;
    try {
      resp = await msalInstance.acquireTokenSilent({
        ...apiTokenRequest,
        account,
      });
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError) {
        // Don't trigger nested popups; full redirect is universally safe.
        await msalInstance.acquireTokenRedirect({
          ...apiTokenRequest,
          account,
        });
        return config;
      }
      throw err;
    }
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${resp.accessToken}`;
    // Once we have a real Bearer token, the dev header is redundant.
    delete config.headers["X-User-Email"];
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[api] failed to acquire access token", err);
  }
  return config;
}

api.interceptors.request.use(attachAuth);
axios.interceptors.request.use(attachAuth);
